import { dataCurta } from "../../lib/format";
import { ENGAJAMENTO_LABEL, ENGAJAMENTO_MAX, type MomentoMusical } from "../types";

/**
 * Linha do tempo do engajamento (P0.4): a evolução do passo ao longo dos momentos.
 * Área que "enche" em verde suave — comunica progresso, não nota. Cada ponto é um
 * momento confirmado; o último é destacado. Reaproveita as classes .timeline do app.
 */
const W = 320;
const H = 110;
const PAD_X = 14;
const PAD_T = 14;
const PAD_B = 22;

export function EngajamentoTimeline({ momentos }: { momentos: MomentoMusical[] }) {
  const pts = momentos
    .filter((m) => m.confirmado)
    .sort((a, b) => a.data_hora.localeCompare(b.data_hora));

  const x = (i: number) =>
    pts.length <= 1 ? W / 2 : PAD_X + (i * (W - 2 * PAD_X)) / (pts.length - 1);
  const y = (passo: number) =>
    PAD_T + (1 - passo / ENGAJAMENTO_MAX) * (H - PAD_T - PAD_B);
  const baseline = y(0);

  if (pts.length === 0) {
    return (
      <div className="timeline-vazio">a linha do tempo aparece após o 1º momento.</div>
    );
  }

  const ultimo = pts[pts.length - 1];
  const rotulo = `evolução em ${pts.length} ${pts.length === 1 ? "momento" : "momentos"}, até "${ENGAJAMENTO_LABEL[ultimo.passo_engajamento]}"`;
  const linha = pts.map((m, i) => `${x(i)},${y(m.passo_engajamento)}`).join(" ");
  const area = `${PAD_X},${baseline} ${linha} ${x(pts.length - 1)},${baseline}`;

  return (
    <svg className="timeline" viewBox={`0 0 ${W} ${H}`} role="img" aria-label={rotulo}>
      {[0, 3, 6, 9].map((p) => (
        <line
          key={p}
          x1={PAD_X}
          x2={W - PAD_X}
          y1={y(p)}
          y2={y(p)}
          className="timeline-grade"
        />
      ))}

      {pts.length > 1 && <polygon points={area} className="timeline-area" />}
      <polyline points={linha} className="timeline-linha" />

      {pts.map((m, i) => {
        const ehUltimo = i === pts.length - 1;
        return (
          <circle
            key={m.id}
            cx={x(i)}
            cy={y(m.passo_engajamento)}
            r={ehUltimo ? 5 : 3.5}
            className={ehUltimo ? "timeline-ponto ultimo" : "timeline-ponto"}
          />
        );
      })}

      <text x={PAD_X} y={H - 6} className="timeline-data" textAnchor="start">
        {dataCurta(pts[0].data_hora)}
      </text>
      {pts.length > 1 && (
        <text x={W - PAD_X} y={H - 6} className="timeline-data" textAnchor="end">
          {dataCurta(ultimo.data_hora)}
        </text>
      )}
    </svg>
  );
}
